import { fetchGet, fetchPost, fetchPut } from '.';
import { constructQueryString } from '../utils/constructQueryString';

export const fetchInspectors = async (options = {}) => {
  const queryString = constructQueryString(options);
  return await fetchGet(`/inspector${queryString}`);
};

export const createInspector = async (body) => {
  return await fetchPost('/inspector', body);
};

export const updateInspector = async (uuid, body) => {
  return await fetchPut(`/inspector/${uuid}`, body);
};

export const fetchInspector = async (uuid) => {
  return await fetchGet('/inspector/' + uuid);
};

export const fetchInspectorsByClient = async (clientUuid) => {
  return await fetchGet(`/inspector/by-client/${clientUuid}`);
};
